import * as angular from "angular";
import * as _ from "lodash";
import {CommonsDialogService} from "../../commons/services/commons-dialog.service";
import {CommonsService} from "../../commons/services/commons-service.service";

export class PlanningCommonService {
  constructor(private planningConstants,
              private commonsConstants,
              private commonsDialogService: CommonsDialogService,
              private $filter,
              private commonsService: CommonsService) {
  }

  getRouteColor(route) {
    if (route.color) {
      return route.color;
    }
    const routeColorPallet = this.commonsConstants.colorPalletRoutes;
    const isAllocation = _.get(route, 'resource.allocationId', false) || _.get(route, 'resource.allocationInstanceId', false);
    const id = isAllocation ? (route.resourceId || _.get(route, 'id')) : _.get(route, 'id');

    return this.commonsService.getColorById(id, routeColorPallet);
  }

  getBarcodesString(activity) {
    let barcodes = [];
    let packages = _.get(activity, 'packages');

    if (!packages) {
      return barcodes;
    }

    _.forEach(packages, function (p) {
      if (!_.isUndefined(p.barcode)) {
        barcodes = _.concat(barcodes, p.barcode);
      }
    })
    return barcodes;
  }

  getActivityPackageTotals(activity) {
    const packages = _.get(activity, 'packages', []);
    return {
      packages: this.$filter('servicePackagesCount')(packages),
      volume: this.$filter('jobPackagesVolume')(packages, true),
      weight: this.$filter('jobPackagesWeight')(packages, true),
      pallets: this.$filter('jobPackagesPallets')(packages),
    }
  }
}

angular
  .module('bringoz.admin.planning')
  .service('planningCommonService', PlanningCommonService);

